import { render, staticRenderFns } from "./SharedIdSearch.vue?vue&type=template&id=143dc67c&scoped=true&"
import script from "./SharedIdSearch.vue?vue&type=script&lang=js&"
export * from "./SharedIdSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143dc67c",
  null
  
)

export default component.exports